import { useSelector } from 'react-redux'
import { useFeatureFlag } from './use-feature-flag'
import { RootState } from '../store/modules/rootReducer'

export default function useGetAppRoutes() {
  const { subscriptions, learningCourses } = useSelector((state: RootState) => ({
    subscriptions: state.subscription.subscriptions,
    learningCourses: state.learningCourses,
  }))

  const hasCourses = learningCourses.data.length > 0
  const isSubscription = subscriptions.length > 0

  const { isEnabled: isQuestionEnabled } = useFeatureFlag('menu_questions')
  const { isEnabled: isVipRoomEnabled } = useFeatureFlag('menu_vip_classroom')
  const { isEnabled: isUpsellPremiumEnabled } = useFeatureFlag('menu_upsell_premium')
  const { isEnabled: isPlanningEnabled } = useFeatureFlag('menu_planning')

  const routes = [
    {
      name: 'Início',
      path: '/home',
      active: true,
      betaTag: false,
    },
    {
      name: 'Questões',
      path: '/questoes',
      active: isQuestionEnabled,
      betaTag: false,
    },
    {
      name: 'Sala VIP',
      path: '/course/652d448fc0734d00343ba192',
      active: isVipRoomEnabled,
      betaTag: false,
    },
    {
      name: 'Sala VIP',
      path: '/premium',
      active: isUpsellPremiumEnabled && !isVipRoomEnabled,
      betaTag: false,
    },
    {
      name: 'Meus conteúdos',
      path: '/my-contents',
      active: isSubscription && !hasCourses ? false : true,
      betaTag: false,
    },
    {
      name: 'Desempenho',
      path: '/desempenho',
      active: true,
      betaTag: false,
    },
    {
      name: 'Planejador',
      path: '/planejamento',
      active: isPlanningEnabled,
      betaTag: true,
    },
    {
      name: 'Assinatura',
      path: '/subscription',
      active: isSubscription,
      betaTag: false,
    },
    {
      name: 'Dúvidas',
      path: '/duvidas',
      active: true,
      betaTag: false,
    },
    {
      name: 'Meus Recados',
      path: '/recados',
      active: true,
      betaTag: false,
    },
    {
      name: 'Prazos de acesso',
      path: '/prazos',
      active: true,
      betaTag: false,
    },
  ] as const

  return routes
}

export type TAppRoutes = ReturnType<typeof useGetAppRoutes>
export type TAppPath = TAppRoutes[number]['path']
